module.exports = __webpack_public_path__ + "img/favorite.6fe370ab.svg";